/* eslint-disable camelcase */
import { useRef, useState } from 'react'

import * as React from 'react'
import { Input } from 'components/forms'
import Spinner from 'shared/spinner'
import { InfoButton } from 'components/buttons'
import { DEFAULT_FEED_ITEMS_PER_PAGE } from 'shared/constants'
import { FeedAdminOverride } from '../FeedAdminTools'
import ViewedContentItems from './ViewedContentItems/ViewedContentItems'
// @ts-ignore-line
import css from './FeedAdminToolsVersion2.scss'

interface FeedAdminToolsVersion2Props {
  isFetchingFeed: boolean
  onSubmit: (overrides: FeedAdminOverride) => void
}

const FeedAdminToolsVersion2 = (props: FeedAdminToolsVersion2Props) => {
  const { isFetchingFeed, onSubmit } = props
  const datePickerRef = useRef<HTMLInputElement>(null)
  const [page, setPage] = useState<undefined | number>()
  const [pageSize, setPageSize] = useState<undefined | number>(
    DEFAULT_FEED_ITEMS_PER_PAGE
  )
  const [user, setUser] = useState<undefined | string>()
  const [milestoneWeek, setMilestoneWeek] = useState<undefined | number>()
  const [visit, setVisit] = useState<undefined | number>()
  const [contentItemServes, setContentItemServes] = useState<
    undefined | string
  >()
  const [currentDatetime, setCurrentDatetime] = useState<undefined | string>()

  const rawPayload = {
    feed_overrides: JSON.stringify({
      content_item_serves: contentItemServes,
      current_datetime: currentDatetime,
      milestone_week: milestoneWeek,
      user,
      visit,
    }),
    per_page: pageSize,
    page,
  }

  // remove undefined keys by converting to JSON and back
  const payload = JSON.parse(JSON.stringify(rawPayload))

  return (
    <>
      <Input
        label="Page"
        placeholder="Enter Page Number"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setPage(
            e.currentTarget.value ? Number(e.currentTarget.value) : undefined
          )
        }
      />
      <Input
        label="Page Size"
        placeholder={`Enter Page Size (default ${DEFAULT_FEED_ITEMS_PER_PAGE})`}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setPageSize(
            e.currentTarget.value ? Number(e.currentTarget.value) : undefined
          )
        }
      />
      <Input
        label="User"
        placeholder="Enter User ID or Email"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setUser(e.currentTarget.value || undefined)
        }
      />
      <Input
        label="Milestone Week"
        placeholder="Enter Milestone Week"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setMilestoneWeek(
            e.currentTarget.value ? Number(e.currentTarget.value) : undefined
          )
        }
      />
      <Input
        label="Visit Number"
        placeholder="Enter Visit Number"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setVisit(
            e.currentTarget.value ? Number(e.currentTarget.value) : undefined
          )
        }
      />
      <div className={css.DateWrapper}>
        <Input
          inputRef={datePickerRef}
          label="Current Date"
          type="datetime-local"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setCurrentDatetime(e.currentTarget.value || undefined)
          }
        />
        <InfoButton
          className={css.DateClearButton}
          onClick={() => {
            if (datePickerRef?.current) {
              datePickerRef.current.value = ''
              setCurrentDatetime(undefined)
            }
          }}
        >
          x
        </InfoButton>
      </div>
      <ViewedContentItems onChange={(val) => setContentItemServes(val)} />
      <InfoButton
        block
        pill
        className="mbm"
        size="large"
        onClick={() => onSubmit(payload)}
      >
        {isFetchingFeed ? (
          <Spinner inverse={false} size="small" />
        ) : (
          'Preview Feed'
        )}
      </InfoButton>
    </>
  )
}

export default FeedAdminToolsVersion2
